function PageNotFound() {
  return (
    <div className="text">
      <p>404 Page not found</p>
    </div>
  );
}

export default PageNotFound;
